export default {
  MuiFab: {
    root: {
      paddingTop: 0,
    },
  },
};
